<template>
	<div class="getReport">

		<!-- 设置系统通知 -->
		<div @click="setEmailNotice" class="email-notice">
			<img src="../assets/systemImg/set_email.png" alt="设置系统通知图标">
			<span>設置系統通知</span>
		</div>

		<div class="step">
			<div class="groupS">
				<el-row :gutter="20">
					<el-col :span="6">
						<div class="groupList">
							<span>預約日期：</span>
							<el-date-picker v-model="dateValue" value-format="timestamp" prefix-icon="clearDateIcon"
								type="daterange" range-separator="~" start-placeholder="開始日期" end-placeholder="結束日期">
							</el-date-picker>

						</div>
					</el-col>
					<el-col :span="4">
						<div class="groupList">
							<span>預約狀態：</span>
							<el-select v-model="value" class="state status" placeholder="请选择">
								<el-option v-for="item in options" class="state-option" :key="item.value"
									:label="item.label" :value="item.value">
								</el-option>
							</el-select>

						</div>
					</el-col>
					<el-col :span="7" style="display: flex; align-items: center; justify-content: flex-start;">
						<button class="nextBtn" style="margin-left: 0;" @click="getReport">搜索</button>
						<el-button @click="handleReset" style="margin-left: 0.2rem;" class="nextBtn">重置</el-button>
						<button type="submit" class="nextBtn" @click="downExcel">批量導出</button>
					</el-col>

				</el-row>

				<div style="clear: both;"></div>
			</div>
		</div>
		<div class="step">
			<!-- <p class="stepTit">客戶評估報告</p> -->
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
				@selection-change="handleSelectionChange" :header-cell-style="{background:'#f0f3f8',color:'#333'}"
				border>
				<el-table-column prop="id" label="編號" width="80">
				</el-table-column>
				<el-table-column prop="user_no" label="USER ID" :width="user_idW">
				</el-table-column>
				<el-table-column prop="username" label="姓名" :width="usernameW">
				</el-table-column>
				<el-table-column prop="mobile" label="手機號碼" :width="phoneW">
				</el-table-column>
				<el-table-column prop="goods_name" label="開通套餐">
				</el-table-column>
				<el-table-column prop="timeOne" label="第一預約信息" 					min-width="120">
					<template slot-scope="scope">
						<div style="display: flex;">
							<div style="width: 70%;float: left;overflow: hidden">
								{{ scope.row.atime}}<br />{{scope.row.address }}</div>
							<div class="caozuo">
								<span class="iconfont icon-xiugaimima" @click="editInfo(scope.row.id)"></span>
								<span @click="selArea(scope.row.id,1)"
									:style="{color: scope.row.confirm == 1 ? '#FABC58' : '#B8BFCC'}" class="iconfont"
									:class="scope.row.confirm == 1 ? 'icon-xingbiaobeifen' : 'icon-xingbiao'"></span>
							</div>
							<div style="clear: both;"></div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="timeTwo" label="第二預約信息" min-width="120">
					<template slot-scope="scope">
						<div style="display: flex;">
							<div style="width: 70%;float: left;overflow: hidden">
								{{ scope.row.atime2}}<br />{{scope.row.address2 }}</div>
							<div class="caozuo" v-if="scope.row.atime2 != '未选择'">
								<span @click="selArea(scope.row.id,2)"
									:style="{color: scope.row.confirm == 2 ? '#FABC58' : '#B8BFCC'}" class="iconfont"
									:class="scope.row.confirm == 2 ? 'icon-xingbiaobeifen' : 'icon-xingbiao'"></span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="created_at" label="預約時間"  min-width="120">
				</el-table-column>
				<el-table-column prop="is_finish" label="狀態" :width="finishW">
				</el-table-column>
			</el-table>
			<el-row :gutter="20" v-show="downFile">
				<el-col :span="12">
					<form :action="http" method="post" autocomplete="off" v-show="false">
						<input type="text" name="startat" :value="dateValue ? dateValue[0] / 1000 : ''">
						<input type="text" name="endat" :value="dateValue ? dateValue[1] / 1000 : ''">
						<input type="text" name="type" :value="value">
						<button type="submit" ref="down">下載成excel文件</button>
					</form>
				</el-col>
			</el-row>
				<el-pagination
				prev-text="上一頁"
				next-text="下一頁" class="pagination qjc-texta-c" hide-on-single-page @current-change="handleCurrentChange"
					layout="total, prev, pager, next,jumper" :page-size="10" :total="pageCount">
				</el-pagination>
		</div>
		<div class="editPopup" v-if="ifEdit">
			<div class="editBox">
				<div class="closeEdit" @click="closeEdit"></div>
				<div class="editTitle">第一預約信息：</div>
				<div class="editGroup">
					<span>进行体检的地点：</span>
					<div style="position: relative">
						<p class="iconfont icon-zhiyuandidian"></p>
						<select id="areaSel" v-model="areaValue" @change="areaValueChange=true"
							:class="{'is-change': areaValueChange}">
							<!-- <option value="">請選擇</option> -->
							<option v-for="(item,index) in areaBookinglist" :value="item.id">{{item.name}}</option>
						</select>
					</div>
				</div>
				<div class="editGroup">
					<span>进行体检的日期与时间：</span>
					<div style="position: relative">
						<el-date-picker v-model="dateEdit" type="date" size="large" :default-value="showDate"
							value-format="timestamp" placeholder="选择日期" :class="{'is-change': dateEditChange}"
							@change="dateChange" :picker-options="pickerOptions">
						</el-date-picker>
						<el-time-select v-model="timeEdit" :picker-options="{
									start: '09:00',
									step: '00:15',
									end: '12:30'
								  }" :class="{'is-change': timeEditChange}" @change="timeEditChange=true" placeholder="选择时间"
							value-format="timestamp">
						</el-time-select>
					</div>
					<div style="clear: both;"></div>
				</div>
				<button type="submit" class="nextBtn" style="margin: 0 auto; padding: 0 0.5rem;margin-top: 0.4rem"
					@click="confirmEdit">確認修改</button>

			</div>
		</div>
		<Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
			@on-confirm="confirmDialog" />

		<!-- 设置系统通知 -->
		<el-dialog class="notice-alert" top="0" :visible.sync="emailNotice" :show-close="false" width="8.5rem">
			<img @click="emailNotice = false" src="../assets/icons/close.png" class="alert-close" alt="">
			<div>
				<h6>保存信息</h6>
				<p>若有新的客戶完成套餐購買與預約，將會發送電郵至指定郵箱提醒您進行處理。</p>
				<p>若您填寫了手機號碼，同時亦會有短訊通知。</p>
				<div class="form">
					<div v-for="(email, index) in emailNoticeVal" :key="index" class="emails">
						<label :for="index>0?'emailNoticeVal'+(index+1):'emailNoticeVal'"><span
								v-if="index == 0">*</span>郵箱地址{{ index>0?index+1:'' }}：</label>
						<el-input :id="index>0?'emailNoticeVal'+(index+1):'emailNoticeVal'" class="emailNoticeVal"
							v-model="email.value" @blur="emailVerify(email.value)"
							:placeholder="'請填寫您需要接收通知的郵箱號碼'+ (index>0?'（选填）':'（必填）')" />
						<i v-if="index>0" @click="removeEmail(index)" class="el-icon-remove-outline"></i>
					</div>
					<div>
						<label for=""></label>
						<span @click="addEmail" class="add-email">+新增郵箱地址</span>
					</div>
					<div>
						<label for="emailNoticeTel">手機號：</label>
						<el-input @input="onlyNumber" @blur="phoneVerify" id="emailNoticeTel" v-model="emailNoticeTel"
							placeholder="請填寫您需要接收通知的手機號碼（選填）">
							<el-select v-model="telArea" class="tel-area" slot="prepend">
								<el-option :value="852"></el-option>
								<el-option :value="86"></el-option>
							</el-select>
						</el-input>
						<label for="emailNoticeTel">驗證碼：</label>
						<el-input id="emailNoticeCode" v-model="emailNoticeCode" placeholder="請填寫驗證碼" maxlength="4" />
						<el-button :class="{ sending: codeSending }" class="send-code" type="primary"
							:disabled="codeSending">
							<span v-if="!codeSending" @click="sendEmailCode">發送驗證碼</span>
							<span v-else>{{ countDown }}秒後重新獲取</span>
						</el-button>
					</div>
					<el-button @click="saveInfo" class="save-notice" type="primary">保存信息</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import bookingInfo from '../assets/js/bookingInfo'

	import Alert from '../components/alert'
	export default {
		components: {
			Alert
		},
		name: "bookingInfo",
		...bookingInfo
	}
</script>

<style scoped>
	
	.status>>>.el-input__inner {
		font-size: 14px;
		height: 36px;
		line-height: 36px;
		width: 120px;
	}
	
	.getReport>>>.el-pager li.active {
		color: white;
		border-radius: 0.02rem;
		background: #6681FA !important;
	}

	.getReport>>>.el-range-editor.el-input__inner {
		float: left;
		height: 36px;
		padding: 0;
	}

	.getReport>>>.el-date-editor .el-range-separator {
		line-height: 36px;
	}

	.getReport>>>.el-select {
		float: left;
	}

	.getReport>>>.el-pagination {
		text-align: center;
	}

	.editPopup>>>.el-select-dropdown__item {
		text-indent: 15px !important;
	}

	.editPopup>>>.el-input {
		margin-top: 0.07rem;
		display: block;
		float: left;
		width: 2.42rem;
		height: 0.4rem;
		font-size: 0.14rem;
	}

	.editPopup>>>.el-input:last-child {
		float: right;
	}

	.editPopup>>>.el-input__icon {
		margin: 0 0.07rem;
		line-height: 0.4rem;
	}

	.editPopup>>>.el-input__inner {
		height: 36px;
		border: 0.01rem solid rgba(213, 216, 222, 1);
		text-indent: 0.1rem;
		color: #C0C4CC;
	}

	.getReport>>>.el-range-input {
		font-size: 14px;
		line-height: 36px;
	}

	.is-change>>>.el-input__inner,
	.is-change#areaSel {
		color: #40444D !important;
	}

	.state>>>.el-input__inner {
		font-size: 14px;
		height: 36px;
		line-height: 36px;
	}

	.state>>>.el-input__icon {
		line-height: 36px;
	}

	/* 设置邮箱弹出框 */
	.notice-alert>>>.el-dialog {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin: 0;
	}

	.notice-alert>>>.el-dialog__header {
		padding: 0;
	}

	.notice-alert>>>.el-dialog__body {
		padding: 0.24rem;
	}

	.notice-alert>>>.el-input input {
		height: 0.36rem;
		line-height: 0.36rem;
		margin-bottom: 0.08rem;
		padding: 0 0.08rem;
		font-weight: bold;
	}

	.notice-alert .emailNoticeVal>>>input {
		width: 7.08rem;
	}

	.notice-alert>>>#emailNoticeTel {
		display: inline-block;
		width: 3rem;
		margin-right: 0.09rem;
		vertical-align: top;
	}

	.notice-alert>>>#emailNoticeCode {
		width: 1.38rem;
		vertical-align: middle;
	}

	.notice-alert>>>.el-input-group__prepend {
		display: inline-block;
		width: 0.6rem;
		height: 0.35rem;
		padding: 0;
		background-color: #fff;
	}

	.notice-alert>>>.el-select__caret.el-input__icon {
		position: relative;
		height: 36px;
	}

	.notice-alert>>>.el-select__caret.el-input__icon:before {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		line-height: 36px;
	}

	.el-select-dropdown__item {
		padding: 0 0.08rem;
	}

	.notice-alert>>>.el-input.is-active .el-input__inner,
	.notice-alert>>>.el-input__inner:focus {
		border-color: #6681FA;
	}
	
	.pagination{
		padding-right: 24px;
		text-align: center;
		margin-top: 6px;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
	}
</style>
<style src="../assets/iconFonts/iconfont.css" scoped>
</style>
<style src="../assets/css/bookingInfo.css" scoped>

</style>